"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Outlined = exports.HeartIconRoot = exports.Filled = void 0;
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const Filled = exports.Filled = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  theme,
  isFavorite
}) => ({
  color: theme.palette.pink[300],
  display: 'none',
  ...(isFavorite && {
    display: 'flex'
  })
}));
const Outlined = exports.Outlined = (0, _mui.styled)('div', {
  shouldForwardProp: (0, _presentationUtils.shouldForwardProp)()
})(({
  theme,
  isFavorite
}) => ({
  color: theme.palette.text.secondary,
  display: 'flex',
  ...(isFavorite && {
    display: 'none'
  })
}));
const HeartIconRoot = exports.HeartIconRoot = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'center',
  display: 'flex',
  fontSize: 'inherit',
  height: '100%',
  justifyContent: 'center',
  width: '100%',
  [theme.breakpoints.up('md')]: {
    '&:hover .filledIcon': {
      display: 'flex'
    },
    '&:hover .outlinedIcon': {
      display: 'none'
    }
  }
}));
